import { spendPersonalInfoContinue } from '../../redirects'
/* istanbul ignore file */
import { FlowEntry, FlowRoute } from '../../types'

// SPEND Flow
const spend: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [{ name: 'continue', stepEvent: 'spend_intro', goTo: () => FlowRoute.Signup }],
    progress: { stepOverallProgress: 0 },
  },
  {
    page: FlowRoute.Signup,
    actions: [{ name: 'continue', stepEvent: 'create_account', goTo: () => FlowRoute.ContactInfo }],
    progress: { stepOverallProgress: 8 },
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_contact',
        goTo: spendPersonalInfoContinue,
      },
      {
        name: 'bank-card-ordered',
        goTo: () => FlowRoute.SpendCoreInterstitial,
      },
    ],
    progress: { stepOverallProgress: 16 },
  },
  {
    page: FlowRoute.PersonalInfo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_personal',
        goTo: () => FlowRoute.Institutions,
      },
    ],
    progress: { stepOverallProgress: 32 },
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      {
        name: 'partner_skip',
        goTo: () => FlowRoute.Prefund,
      },
      {
        name: 'skip',
        goTo: () => FlowRoute.Prefund,
      },
      {
        name: 'continue',
        stepEvent: 'link_bank',
        goTo: () => FlowRoute.Prefund,
      },
      {
        name: 'choose',
        goTo: () => FlowRoute.ChooseFundingSource,
      },
      {
        name: 'manual',
        goTo: () => FlowRoute.ManualFundingSource,
      },
      {
        name: 'direct',
        goTo: () => FlowRoute.DirectBankIntegration,
      },
    ],
    progress: { stepOverallProgress: 40 },
  },
  {
    page: FlowRoute.PlaidLinkRedirect,
    actions: [
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      {
        name: 'choose',
        goTo: () => FlowRoute.ChooseFundingSource,
      },
      {
        name: 'continue',
        stepEvent: 'link_bank',
        goTo: () => FlowRoute.Prefund,
      },
      {
        name: 'manual',
        goTo: () => FlowRoute.ManualFundingSource,
      },
    ],
    progress: { stepOverallProgress: 40 },
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'partner_skip', goTo: () => FlowRoute.Prefund },
      { name: 'skip', goTo: () => FlowRoute.Prefund },
      { name: 'continue', goTo: () => FlowRoute.Prefund },
    ],
    progress: { stepOverallProgress: 40 },
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      {
        name: 'continue',
        stepEvent: 'link_bank',
        goTo: () => FlowRoute.Prefund,
      },
    ],
    progress: { stepOverallProgress: 40 },
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      {
        name: 'continue',
        stepEvent: 'link_bank',
        goTo: () => FlowRoute.Prefund,
      },
      {
        name: 'manual',
        goTo: () => FlowRoute.ManualFundingSource,
      },
      {
        name: 'different-bank',
        goTo: () => FlowRoute.Institutions,
      },
    ],
    progress: { stepOverallProgress: 40 },
  },
  {
    page: FlowRoute.Prefund,
    actions: [{ name: 'continue', stepEvent: 'spend_prefund', goTo: () => FlowRoute.SignYourCard }],
    progress: { stepOverallProgress: 48 },
  },
  {
    page: FlowRoute.SignYourCard,
    actions: [
      {
        name: 'continue',
        stepEvent: 'spend_card_signature',
        goTo: () => FlowRoute.SpendOrderConfirmation,
      },
      {
        name: 'bank-card-ordered',
        goTo: () => FlowRoute.SpendCoreInterstitial,
      },
    ],
    progress: { stepOverallProgress: 56 },
  },
  {
    page: FlowRoute.SpendOrderConfirmation,
    actions: [
      {
        name: 'continue',
        stepEvent: 'spend_order_confirmation',
        goTo: () => FlowRoute.SpendCoreInterstitial,
      },
      {
        name: 'skip',
        goTo: () => FlowRoute.SpendCoreInterstitial,
      },
      {
        name: 'edit-signature',
        goTo: () => FlowRoute.SignYourCard,
      },
      {
        name: 'edit-address',
        goTo: () => FlowRoute.ContactInfo,
      },
    ],
    progress: { stepOverallProgress: 64 },
  },
  {
    page: FlowRoute.SpendCoreInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'spend_core_interstitial',
        goTo: () => FlowRoute.SuitabilityQuestions,
      },
    ],
    progress: { stepOverallProgress: 72 },
  },
  {
    page: FlowRoute.SuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_questions',
        goTo: () => FlowRoute.InvestorQuestions,
      },
    ],
    progress: { stepOverallProgress: 80 },
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_investor_questions',
        goTo: () => FlowRoute.Analyzing,
      },
    ],
    progress: { stepOverallProgress: 86 },
  },
  {
    page: FlowRoute.Analyzing,
    actions: [
      {
        name: 'continue',
        stepEvent: 'analyzing_portfolio',
        goTo: () => FlowRoute.PortfolioOverview,
      },
    ],
    progress: { stepOverallProgress: 92 },
  },
  {
    page: FlowRoute.PortfolioOverview,
    actions: [
      { name: 'continue', stepEvent: 'portfolio_breakdown', goTo: () => FlowRoute.Success },
    ],
    progress: { stepOverallProgress: 96 },
  },
  {
    page: FlowRoute.Success,
    actions: [],
    progress: { stepOverallProgress: 100 },
  },
]

export default spend
